<template>
  <VaDropdown :offset="[13, 0]" class="notification-dropdown" stick-to-edges :close-on-content-click="false">
    <template #anchor>
      <VaButton preset="secondary" color="textPrimary" round>
        <span class="profile-dropdown__anchor min-w-max">
          <VaBadge v-if="totalNotifications > 0" overlap style="position: absolute; top: -1px; right: 0px">
            <template #text> {{ totalNotifications }}+</template>
          </VaBadge>
          <VaIcon aria-hidden="true" name="notifications" size="32px" color="primary" />
        </span>
      </VaButton>
    </template>
    <VaDropdownContent class="h-full sm:max-w-[420px] sm:h-auto">
      <section class="sm:max-h-[320px] p-4 overflow-auto">
        <VaList class="space-y-1 mb-2">
          <p class="text-secondary" style="margin-top: 10px">{{ $t('reminders.currentNotifications') }}</p>
          <template v-for="(item, index) in notifications" :key="item.id">
            <VaListItem class="text-base">
              <!--VaListItemSection icon class="mx-0 p-0">
                <VaIcon :name="item.icon" color="secondary" />
              </VaListItemSection-->
              <VaListItemSection>
                {{ item.detail }}
              </VaListItemSection>
              <VaListItemSection icon class="mx-1">
                {{ item.date }}
              </VaListItemSection>
            </VaListItem>
          </template>
          <VaListSeparator class="mx-3" />

          <p class="text-secondary" style="margin-top: 10px">{{ $t('reminders.lastNotifications') }}</p>
          <template v-for="(item, index) in oldNotifications" :key="item.id">
            <VaListItem class="text-base">
              <VaListItemSection>
                {{ item.detail }}
              </VaListItemSection>
              <VaListItemSection icon class="mx-1">
                {{ item.date }}
              </VaListItemSection>
            </VaListItem>
          </template>
        </VaList>

        <!--VaButton preset="primary" class="w-full" @click="displayAllNotifications = !displayAllNotifications"
          >{{ displayAllNotifications ? t('notifications.less') : t('notifications.all') }}
        </VaButton-->
      </section>
    </VaDropdownContent>
  </VaDropdown>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import { useI18n } from 'vue-i18n'
import { useReminder } from '../../../../pages/reminders/composables/useReminder'
import { onMounted } from 'vue'
const { t, locale } = useI18n()
const { getAllNotifications } = useReminder()
const totalNotifications = ref(0)
const notifications = ref([])
const oldNotifications = ref([])
onMounted(async () => {
  const { todayNotifications, yesterdayNotifications } = await getAllNotifications()
  notifications.value = todayNotifications
  oldNotifications.value = yesterdayNotifications
  totalNotifications.value = todayNotifications?todayNotifications.length:0
})
</script>

<style lang="scss" scoped>
.notification-dropdown {
  cursor: pointer;

  .notification-dropdown__icon {
    position: relative;
    display: flex;
    align-items: center;
  }

  .va-dropdown__anchor {
    display: inline-block;
  }
}
</style>
